import { Pipe, PipeTransform } from '@angular/core';

export interface AssignedProModel {
  id?: number | null;
  first_name?: string | null;
  last_name?: string | null;
}

const normalizeName = (name: string | null | undefined): string =>
  (name || '').trim().toLowerCase();

// The back end lists every saved pro without a history record as `did_not_contact`, including the
// pro already assigned to the job. Its rows carry only the pro's full name (no homekeeper_id), so
// match by id when one is present and fall back to the name the back end splits into first/last.
export const isAssignedProDidNotContact = (item: any, assignedPros: AssignedProModel[] | null | undefined): boolean => {
  if (item?.data?.type !== 'did_not_contact' || !assignedPros?.length) {
    return false;
  }
  const homekeeperId = item.data.homekeeper_id;
  if (homekeeperId !== null && homekeeperId !== undefined) {
    return assignedPros.some(pro => pro?.id === homekeeperId);
  }
  const nameParts = normalizeName(item.text).split(/\s+/).filter(Boolean);
  if (!nameParts.length) {
    return false;
  }
  const firstName = nameParts[0];
  const lastName = nameParts[nameParts.length - 1];
  return assignedPros.some(pro =>
    !!pro?.first_name &&
    normalizeName(pro.first_name) === firstName &&
    normalizeName(pro.last_name || pro.first_name) === lastName
  );
};

@Pipe({
    name: 'hideAssignedProDidNotContact',
    standalone: false,
    pure: true
})
export class HideAssignedProDidNotContactPipe implements PipeTransform {
  transform(items: any[] | null | undefined, assignedPros: AssignedProModel[] | null | undefined): any[] {
    if (!items) {
      return [];
    }
    if (!assignedPros?.length) {
      return items;
    }
    return items.filter(item => !isAssignedProDidNotContact(item, assignedPros));
  }
}
